import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import { RoutedApp } from "./routing/RoutedApp";
import { ToastProvider } from "./state/use-toast";
import { PresentationBoundary, reportPresentationFailure } from "./components/PresentationBoundary";
import "./styles/tokens.css";
import "./styles/global.css";
import "./styles/app.css";
import "./styles/responsive.css";

const root = document.getElementById("root");
if (!root) throw new Error("root element missing");
const reactRoot = createRoot(root, {
  // Boundaries own sanitized caught diagnostics; React's default includes raw
  // errors/stacks. Uncaught failures also use a fixed record without payloads.
  onCaughtError: () => {},
  onUncaughtError: () => reportPresentationFailure("application"),
});
reactRoot.render(<StrictMode><PresentationBoundary feature="application"><ToastProvider><BrowserRouter><RoutedApp /></BrowserRouter></ToastProvider></PresentationBoundary></StrictMode>);
if (import.meta.hot) import.meta.hot.dispose(() => reactRoot.unmount());
